import { render, staticRenderFns } from "./AssignCategoryModal.vue?vue&type=template&id=fd7951a6&"
import script from "./AssignCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AssignCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports